export default __webpack_public_path__ + "images/3179d27379774d47a0985abc3d7385d2.png";